import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';

const { spacing, colors, typography, borderRadius } = tokens;

export const placeholder = ({
  width,
  minHeight,
}: {
  width?: number;
  minHeight?: number;
}) => css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs};
  box-sizing: border-box;
  padding: ${spacing.xxs};
  ${width ? `width: ${width}px;` : ''}
  ${minHeight ? `min-height: ${minHeight}px;` : ''}
  max-width: 100%;
  border: 1px dashed ${colors.neutral.base.default};
  border-radius: ${borderRadius.outer};
  background-color: ${colors.neutral.surface.default};
  text-align: center;
`;

export const detail = css`
  ${applyFont(typography.bodyBold)}
  color: ${colors.neutral.heavy.default};
  flex: 0 0 100%;
`;

export const label = css`
  ${applyFont(typography.miniBold)}
  color: ${colors.neutral.heavy.default};
`;

export const ticket = css`
  ${applyFont(typography.mini)}
  color: ${colors.neutral.medium.default};
`;
